// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__CRxwT","mainContent":"MainLayout_mainContent__cAB-7"};